import $ from 'jquery';
import Menu from '../components/Menu';
import Cart from '../components/Cart';

export default class StaticCart {
  constructor(section) {
    this.$el = $(section.el);
    this.data = section.data;
    this.events = [];
    // Shipping calculator
    this.$shippingToggle = this.$el.find('[data-shipping-calculator-toggle]');
    this.$shippingFieldsInline = this.$el.find('.shipping-calculator-inline .shipping-calculator-fields');

    Shopify.Cart.ShippingCalculator.show({
      submitButton: this.data.button_update_shipping_title,
      submitButtonDisabled: this.data.button_update_shipping_disabled_title,
      customerIsLoggedIn: this.data.customer_logged_in,
      moneyFormat: window.Theme.moneyFormat,
    });

    this.events.push(this.$shippingToggle.on('click.cart', (event) => {
      event.preventDefault();
      this._toggleInlineShippingCalculator();
    }));

    this.events.push($('[data-shipping-calculator-submit]', this.$el).on('click.cart', this._calculateShipping.bind(this)));
    this.events.push($('#address_zip', this.$el).on('keydown.cart', this._calculateShipping.bind(this)));

    // Menu system
    this.states = {
      default: {
        buttonsSelector: '[data-cart-menu-buttons-default]',
        buttons: [
          {
            selector: '[data-cart-menu-button-calculate-shipping]',
            callback: () => { this.menu.changeState(this.states.shippingCalculator); },
          },
        ],
      },
      shippingCalculator: {
        slideoutSelector: '[data-cart-menu-slideout]',
        buttonsSelector: '[data-cart-menu-buttons-shipping-calculator]',
        buttons: [
          {
            selector: '[data-cart-menu-slideout-button-dismiss]',
            callback: () => { this.menu.changeState(this.states.default); },
          },
          {
            selector: '[data-cart-menu-button-cancel-shipping]',
            callback: () => { this.menu.changeState(this.states.default); },
          },
          {
            selector: '[data-cart-menu-button-update-shipping]',
            // None needed, Shopify.Cart.ShippingCalculator takes care of this
            callback: () => {},
          },
        ],
        dismiss: () => { this.menu.changeState(this.states.default); },
      },
    };

    this.$cartMenuContainer = $('[data-cart-menu-container]', this.$el);
    this.menu = new Menu(this.$cartMenuContainer, this.states, this.states.default);
    Cart.addCart(section.el, section.postMessage);
  }

  _calculateShipping(e) {
    if (e && (e.type === 'keydown')) {
      if (e.keyCode === 13) {
        e.preventDefault();
        $('.shipping-calculator-response', this.$el).empty();
      } else {
        return;
      }
    }

    const shippingAddress = {};
    shippingAddress.zip = $('#address_zip', this.$el).val() || '';
    shippingAddress.country = $('#address_country', this.$el).val() || '';
    shippingAddress.province = $('#address_province', this.$el).val() || '';

    const queryString = Object.keys(shippingAddress)
      .map(key => `${encodeURIComponent(`shipping_address[${key}]`)}=${encodeURIComponent(shippingAddress[key])}`)
      .join('&');

    $.ajax(`/cart/shipping_rates.json?${queryString}`, { dataType: 'json' })
      .fail(error => this._handleErrors(error.responseJSON || {}))
      .done(response => {
        const rates = response.shipping_rates;

        let address = `${shippingAddress.zip}, ${shippingAddress.province}, ${shippingAddress.country}`;
        if (!shippingAddress.province.length) {
          address = `${shippingAddress.zip}, ${shippingAddress.country}`;
        }
        if (!shippingAddress.zip.length) {
          address = `${shippingAddress.province}, ${shippingAddress.country}`;
        }
        if (!shippingAddress.province.length || !shippingAddress.zip.length) {
          address = shippingAddress.country;
        }

        $('.shipping-calculator-response', this.$el)
          .empty()
          .append('<p class="shipping-rates-feedback" id="shipping-rates-feedback"></p><ul class="shipping-rates"></ul>');

        const ratesFeedback = $('.shipping-rates-feedback', this.$el);
        if (rates.length > 1) {
          const firstRate = Shopify.Cart.ShippingCalculator.formatRate(rates[0].price);
          const multipleShippingRates = window.Theme.shippingCalcMultiRates
            .replace('--address--', address)
            .replace('--number_of_rates--', rates.length)
            .replace('--rate--', `<span class='money'>${firstRate}</span>`);
          ratesFeedback.html(multipleShippingRates);
        } else if (rates.length === 1) {
          const oneShippingRate = window.Theme.shippingCalcOneRate
            .replace('--address--', address);
          ratesFeedback.html(oneShippingRate);
        } else {
          ratesFeedback.html(window.Theme.shippingCalcNoRates);
        }

        const $cartShippingRates = $('.shipping-rates', this.$el);

        for (let i = 0; i < rates.length; i++) {
          const rate = rates[i];
          const price = Shopify.Cart.ShippingCalculator.formatRate(rate.price);
          const rateValues = window.Theme.shippingCalcRateValues
            .replace('--rate_title--', rate.name)
            .replace('--rate--', `<span class='money'>${price}</span>`);

          $cartShippingRates.append(`<li>${rateValues}</li>`);
        }
      });
  }

  _handleErrors(errors) {
    if (errors.zip.length > 0) {
      const zipMessage = window.Theme.shippingCalcErrorMessage.replace('--error_message--', errors.zip);
      $('.shipping-calculator-response', this.$el)
        .empty()
        .append(`<p class="shipping-rates-feedback" id="shipping-rates-feedback">${zipMessage}</p>`);
    } else {
      console.warn(errors);
    }
  }

  _toggleInlineShippingCalculator() {
    // Toggle form
    this.$shippingFieldsInline.toggle();

    // Toggle button text
    const text = this.$shippingToggle.data('toggle-text');
    this.$shippingToggle.data('toggle-text', this.$shippingToggle.text());
    this.$shippingToggle.text(text);
  }

  onSectionMessage(name, data) {
    if (name === 'header-minicart:open') {
      const transitionEnded = $.Deferred();
      data(transitionEnded);
      this.$cartMenuContainer.one('transitionend', () => transitionEnded.resolve());
      this.menu.minimizeMenu();
    }
    if (name === 'header-minicart:close') {
      this.menu.maximizeMenu();
    }
  }

  onSectionUnload() {
    this.events.forEach($el => $el.off('.cart'));
  }
}
